export default "__VITE_ASSET__CZd9ExD7__ 640w, __VITE_ASSET__BapS7k6N__ 1024w, __VITE_ASSET__xzAxiZbL__ 1536w";